
import OrderRepository from "@/repositories/OrderRepository";
import TicketRepository from "@/repositories/TicketRepository";

const repositories = {
    'orders': OrderRepository,
    'tickets': TicketRepository,
}
export default {
    get: name => repositories[name]
};